/* eslint-disable prettier/prettier */
import { TranslationMap } from './default'

// eslint-disable-next-line @typescript-eslint/camelcase
export const zh_TW: TranslationMap = {
  "accountstatus.Active": "有效",
  "accountstatus.Inactive": "無效",
  "accountstatus.Terminated": "已終止",
  "additionalitems.title": "附加項目",
  "cart.addtocart": "添加到購物車",
  "cart.addtocart.alreadyincart": "@@PRODUCT@@ 已在您的購物車中",
  "cart.addtocart.currencylocked": "您的購物車目前設置為@@CURRENCY@@。無法在一個訂單中合併多種貨幣。要購買此產品，請先清除您的@@SHOPPING_CART@@。",
  "cart.addtocart.locked": "您的購物車貨幣已設置為@@CURRENCY@@ 並具有以下收貨地點@@LOCATION@@",
  "cart.addtocart.shiptolocked": "您的購物車已設置收貨地點為@@LOCATION@@ 要購買此產品，請先更改您@@SHOPPING_CART@@ 中的收貨地點",
  "cart.addtocart.success": "@@PRODUCT@@ 已添加到您的購物車",
  "cart.empty": "您的購物車目前是空的",
  "cart.empty.title": "您的購物車是空的",
  "cart.gotoproductlist": "進入產品列表",
  "cart.nolongervalid": "您的購物車無效，請更新以繼續",
  "cart.recalculate": "重新計算",
  "cart.recalculate.rounding": "所需的數量已四捨五入以配合包裝尺寸。",
  "cart.removefromcart.success": "@@PRODUCT@@ 已成功從您的購物車中刪除",
  "cart.removeproduct": "您確定要從購物車中刪除 @@PRODUCT@@ 嗎？",
  "cart.requestquote": "索取報價",
  "cart.updatecart": "更新",
  "cart.updatecart.success": "@@PRODUCT@@ 已更新在您的購物車中",
  "dangerousgoodsclass.1": "爆炸物 (1)",
  "dangerousgoodsclass.2.1": "易燃氣體 (2.1)",
  "dangerousgoodsclass.2.2": "不可燃氣體 (2.2)",
  "dangerousgoodsclass.2.3": "有毒氣體 (2.3)",
  "dangerousgoodsclass.3": "易燃液體 (3)",
  "dangerousgoodsclass.4.1": "易燃固體 (4.1)",
  "dangerousgoodsclass.4.2": "易燃固體可燃物 (4.2)",
  "dangerousgoodsclass.4.3": "潮濕時危險 (4.3)",
  "dangerousgoodsclass.5.1": "氧化 (5.1)",
  "dangerousgoodsclass.6.1": "有毒 (6.1)",
  "dangerousgoodsclass.6.2": "生物危害 (6.2)",
  "dangerousgoodsclass.7": "放射性 (7)",
  "dangerousgoodsclass.8": "腐蝕性 (8)",
  "dangerousgoodsclass.9": "雜項 (9)",
  "date.invalid": "所選日期無效",
  "datefilteroption.last3Months": "過去 3 個月",
  "datefilteroption.lastMonth": "上個月",
  "datefilteroption.lastWeek": "上週",
  "datefilteroption.lastYear": "去年",
  "field.duplicatedphonenumber": "電話號碼已存在",
  "field.invalid": "@@VALUE@@ 無效",
  "field.invalidinternalemail": "電子郵件無效，必須由 brenntag.com、brenntag-asia.com 或 digib.com 提供",
  "field.invalidphonenumber": "電話號碼無效，使用格式 61212345678",
  "field.required": "@@VALUE@@ 是必需的",
  "filter.accessStatus": "權限狀態",
  "filter.all": "都",
  "filter.allorders": "所有訂單",
  "filter.allproducts": "所有產品",
  "filter.apply": "套用",
  "filter.brenntagOrderNumber": "Brenntag 訂單號",
  "filter.compliancerequired": "合規要求",
  "filter.createddate": "創建日期",
  "filter.customerName": "客戶名稱",
  "filter.customerNumber": "客戶號碼",
  "filter.customerpo.placeholder": "按客戶訂單編號篩選",
  "filter.customerponumber": "客戶採購單號",
  "filter.dangerousgoods": "危險品 (Dangerous goods)",
  "filter.deliveryNumber": "交貨編號",
  "filter.deliverydate": "要求的交貨日期",
  "filter.enddate": "結束日期",
  "filter.filterby": "進階篩選",
  "filter.filters": "篩選",
  "filter.from": "從",
  "filter.hazardous": "危害性化學品 (Hazardous goods)",
  "filter.invoicenumber": "發票號碼",
  "filter.lastlogindate": "最後登入日期",
  "filter.myorders": "我的訂單",
  "filter.myproducts": "我的產品",
  "filter.noresults": "未找到結果",
  "filter.orderdate": "訂購日期",
  "filter.otherfilters": "其他篩選",
  "filter.pill.accessStatus": "權限狀態",
  "filter.pill.brenntagOrderNumber": "Brenntag 訂單號碼 #",
  "filter.pill.createdDate": "創建日期",
  "filter.pill.customerPONumber": "採購單號#",
  "filter.pill.dangerousGoods": "危險品  (Dangerous goods)",
  "filter.pill.deliveryDate": "要求的交貨日期",
  "filter.pill.dueDate": "到期日",
  "filter.pill.hazardousGoods": "危害性化學品 (Hazardous goods)",
  "filter.pill.invoiceNumber": "發票號碼",
  "filter.pill.issueDate": "發票日期",
  "filter.pill.lastLoginDate": "登入日期",
  "filter.pill.orderDate": "訂購日期",
  "filter.pill.packageType": "包裝類型",
  "filter.pill.pricePointExists": "有定價的產品",
  "filter.pill.productName": "產品名稱",
  "filter.pill.productNumber": "產品編號",
  "filter.pill.quoteDate": "報價日期",
  "filter.pill.requestedDeliveryDate": "要求交貨",
  "filter.pill.resetAll": "重設所有篩選條件",
  "filter.pill.role": "角色",
  "filter.pill.salesGroupId": "銷售組織",
  "filter.pill.searchQuery": "搜索",
  "filter.pill.shipToLocationId": "收貨人",
  "filter.pill.status": "狀態",
  "filter.pill.updatedDate": "更新日期",
  "filter.pill.userName": "用戶",
  "filter.placeholder.customerName": "按客戶名稱搜索",
  "filter.placeholder.customerNumber": "按客戶編號搜索",
  "filter.placeholder.global": "搜索產品、訂單或發票...",
  "filter.placeholder.userEmail": "透過email搜尋",
  "filter.placeholder.username": "按名稱搜索",
  "filter.pricePointExists": "有定價的產品",
  "filter.productName": "產品名稱",
  "filter.quoteNumber": "報價編號",
  "filter.quotedate": "報價日期",
  "filter.role": "角色",
  "filter.salesRepName": "銷售代表姓名",
  "filter.salesorganisation": "銷售組織",
  "filter.search-salesorg.placeholder": "按客戶或銷售組織搜索",
  "filter.search.placeholder": "搜索",
  "filter.shipto": "收貨人",
  "filter.startdate": "開始日期",
  "filter.status": "狀態",
  "filter.until": "至",
  "filter.updated": "更新",
  "filter.user": "用戶",
  "filter.userEmail": "Email",
  "filter.userName": "名稱",
  "footer.contactus": "聯繫我們",
  "footer.faqs": "常見問題",
  "footer.privacypolicy": "數據保護和隱私聲明",
  "footer.termsofuse": "使用條款",
  "home.contact.1": "聯絡 Brenntag  Connect團隊",
  "home.contact.2": "常見問答集",
  "home.heading.1": "您好，@@USERNAME@@",
  "home.heading.2": "歡迎使用Brenntag Connect！",
  "home.heading.3": "Brenntag Connect是您的在線平台，可輕鬆訂購化學品並獲取最新信息。",
  "home.heading.4": "Quick actions",
  "home.invoices.list.1": "查看商業發票",
  "home.invoices.list.2": "下載發票PDF檔",
  "home.label.explore": "探索",
  "home.label.viewinvoices": "查看所有商業發票",
  "home.label.vieworders": "查看所有訂單",
  "home.orders.list.1": "檢視訂單歷史記錄和狀態",
  "home.orders.list.2": "下載COA",
  "home.products.list.1": "搜尋Brenntag目錄",
  "home.products.list.2": "查看和下載SDS/TDS 文件",
  "home.products.list.3": "訂購產品",
  "home.profile.list.1": "匯出發票資料",
  "home.profile.list.2": "匯出訂單資料",
  "home.profile.list.3": "重置密碼",
  "home.recent.invoices.due": "最近到期的發票",
  "home.recent.invoices.issued": "最近開具的發票",
  "home.recent.orders.created": "最近創建的訂單",
  "home.recent.orders.updated": "最近更新的訂單",
  "invoice.customer": "客戶",
  "invoice.date": "創建日期",
  "invoice.dueDate": "發票到期日",
  "invoice.noinvoicesfound": "目前還沒有發票。我們僅在完成訂單發貨後才開具發票。",
  "invoice.number": "發票號碼",
  "invoicestatus.Cancelled": "已取消",
  "invoicestatus.Open": "處理中",
  "invoicestatus.Paid": "已付款",
  "invoicestatus.PaidOnline": "線上付款",
  "invoicestatus.ProcessingPayment": "處理付款",
  "isolanguage.en": "English",
  "isolanguage.id": "Bahasa Indonesia",
  "isolanguage.ko": "한국어",
  "isolanguage.th": "ไทย",
  "isolanguage.vi": "Tiếng Việt",
  "isolanguage.zh-CN": "中文（簡體）",
  "isolanguage.zh-TW": "中文（繁體）",
  "label.Landline": "電話",
  "label.Mobile": "手機號碼",
  "label.additionalinformation": "附加信息",
  "label.addresses": "地址",
  "label.alternativesizes": "替代尺寸",
  "label.amountdue": "應付金額",
  "label.any": "任何",
  "label.anyquestions": "有什麼問題嗎？",
  "label.batchamount": "批量",
  "label.batchnumber": "批號",
  "label.batchsize": "批量大小",
  "label.billingaddress": "付款人地址",
  "label.billtoaddress": "付款人地址",
  "label.billtoaddresses": "付款人地址",
  "label.billtoaddressincorrect": "要更改您的詳細地址資訊， 請通過 Chat",
  "label.billtoaddressrequired": "付款人地址為必填",
  "label.brenntagordernumber": "Brenntag 訂單號",
  "label.browseproducts": "瀏覽產品",
  "label.browseusers": "瀏覽用戶",
  "label.button.attach": "附件",
  "label.button.changesalesorg": "是的，更改銷售組織",
  "label.button.editprofile": "編輯我的個人資料",
  "label.button.export": "出口",
  "label.button.nokeep": "不，保留",
  "label.button.update": "更新",
  "label.button.yesterminate": "是，終止",
  "label.by": "由",
  "label.callus": "聯絡我們",
  "label.cancel": "取消",
  "label.category": "類別",
  "label.changepassword": "重設密碼",
  "label.changesalesorg": "更改銷售組織",
  "label.changesalesorgwarning": "您確定要更改銷售組織嗎？",
  "label.checkingavailability": "檢查供貨情形…",
  "label.clickheretoreview": "單擊此處查看我們的",
  "label.comments": "備註",
  "label.company": "公司",
  "label.confirmeddeliveryamount": "確認發貨數量",
  "label.continueshopping": "繼續購物",
  "label.country": "國家",
  "label.creationdate": "創建日期",
  "label.creditnote": "折讓單",
  "label.customer": "客戶",
  "label.customername": "客戶名稱",
  "label.customernumber": "客戶編號",
  "label.customerponumber": "客戶採購單號",
  "label.customerporeference": "客戶訂單參考號碼",
  "label.customerporeferencemaxlength": "客戶 PO 參考號碼不能超過 @@LENGTH@@ 個字",
  "label.customerporeferencerequired": "客戶 PO 參考號碼為必要",
  "label.dangerousgoodsclass": "危險品等級",
  "label.dangerousgoodscode": "DG",
  "label.datedelivered": "交貨日期",
  "label.datefrom": "日期從",
  "label.dateissued": "創建日期",
  "label.dateto": "日期至",
  "label.debitnote": "Debit note",
  "label.defaultlanguage": "語言",
  "label.delete": "刪除",
  "label.deliverynumber": "交貨編號",
  "label.details": "詳細內容",
  "label.discountperpack": "每包折扣",
  "label.distributionchannel": "分銷渠道",
  "label.division": "區域",
  "label.documents": "下載文件",
  "label.dontshowthis": "不再顯示此內容",
  "label.download.all": "下載全部",
  "label.download.pdf": "下載PDF檔",
  "label.editmode": "編輯模式",
  "label.email": "Email address",
  "label.emailaddress": "Email address",
  "label.exportdata": "資料輸出",
  "label.exporting": "正在導出數據，可能需要一點時間...",
  "label.exportingerror": "導出文件時出錯，請重試。",
  "label.exportinglonger": "仍在導出數據，可能需要一些時間。",
  "label.exportingsuccess": "數據文件導出成功。",
  "label.exportordersinvoicescsv": "將訂單和發票的結構化數據直接導出為 CSV 或 Excel (XLSX) 文件。",
  "label.exportselectcategory": "為導出文件選擇類別和日期範圍。",
  "label.externaluserfile": "外部用戶文件",
  "label.filesattached": "附加文件",
  "label.from": "從：",
  "label.fullname": "全名",
  "label.hazardousgoodscode": "HZ",
  "label.hazchem": "危害化學品",
  "label.internaluserfile": "內部用戶文件",
  "label.invoice": "發票",
  "label.invoice.status.Cancelled": "已取消",
  "label.invoice.status.Open": "處理中",
  "label.invoice.status.Paid": "已付款",
  "label.invoice.status.PaidOnline": "線上付款",
  "label.invoice.status.ProcessingPayment": "處理付款",
  "label.item": "項目",
  "label.items": "項目",
  "label.language": "語言",
  "label.lastlogin": "上次登入",
  "label.learn_more_about_brenntag": "了解更多有關 Brenntag Connect 的信息",
  "label.logout": "登出",
  "label.minimumquantity": "最小數量",
  "label.myprofile": "我的個人資料",
  "label.name": "全名",
  "label.next-step": "下一步",
  "label.no": "沒有",
  "label.no-filesattached": "沒有附加的文件",
  "label.no-filesuploaded": "沒有上傳的文件",
  "label.none": "無",
  "label.nopriceavailable": "尚無報價",
  "label.notes": "備註",
  "label.orderNumber": "訂單號碼",
  "label.orderamount": "訂單數量",
  "label.orderamount.zero": "訂單數量不能為 0，您可以在購物車中刪除產品。",
  "label.orderdate": "訂購日期",
  "label.orderdetails": "訂單詳細信息",
  "label.orderfiles": "訂單文件",
  "label.orderlist": "訂單列表",
  "label.ordervalue": "訂單金額",
  "label.pack": "包裝",
  "label.packaging": "包裝",
  "label.packaginginformation": "包裝信息",
  "label.packinggroup": "Packing group",
  "label.packsize": "包裝尺寸",
  "label.packtype": "包裝類型",
  "label.paymentreference": "付款憑據",
  "label.paymentterms": "付款條件",
  "label.payonline": "線上付款",
  "label.personalinfo": "用戶信息",
  "label.phonenumber": "電話號碼",
  "label.placeorder": "下訂單",
  "label.placingorder": "下單",
  "label.preferences": "首選項",
  "label.previous-step": "前一步",
  "label.price": "價格",
  "label.priceperpack": "每包價格",
  "label.pricesareexclusiveofsurcharges": "價格不包括附加費或稅費。",
  "label.pricesaresubjecttochange": "報價隨時可能更改。",
  "label.productname": "產品名稱",
  "label.productnumber": "產品編號",
  "label.products": "產品",
  "label.producttype": "產品類別",
  "label.profile": "個人資料",
  "label.purchaseOrderNumber": "客戶採購單號",
  "label.quantity": "數量",
  "label.quantity.minimumorderamount": "數量必須大於或等於@@MINIMUMORDERAMOUNT@@",
  "label.quantity.minimumorderquantity": "數量必須大於或等於@@MINIMUMORDERQUANTITY@@",
  "label.quantity.tiereddiscounts": "提供數量折扣",
  "label.quantity.toolarge": "數值太大",
  "label.quantity.zero": "數值必須大於 0",
  "label.quotedate": "報價日期",
  "label.quotenumber": "報價編號",
  "label.records": "項目",
  "label.redirecttoadmin": "進入管理界面",
  "label.remove": "移除",
  "label.removeproduct": "移除產品",
  "label.reorder": "再次訂購",
  "label.reorderall": "全部再次訂購",
  "label.requestcancellation": "要求取消",
  "label.requestedamount": "需求數量",
  "label.requesteddeliverydate": "要求的交貨日期",
  "label.requesteddeliverydate.tooltip": "請注意，我們無法始終保證您要求的交貨日期。交付視供應情況而定，及我們 Brenntag 團隊的確認。",
  "label.requesteddeliverydate.warning": "視情況而定，並由 Brenntag 團隊確認。",
  "label.requesteddeliverydaterequired": "要求的交貨日期為必填項",
  "label.requestquote": "索取報價",
  "label.retry": "重試",
  "label.role": "角色",
  "label.role.Admin": "管理員",
  "label.role.CSR": "CSR",
  "label.role.ReadUser": "讀取用戶",
  "label.role.SuperAdmin": "超級管理員",
  "label.role.User": "用戶",
  "label.role.UserAdmin": "用戶管理員",
  "label.role.UserManager": "用戶經理",
  "label.salesorganisation": "銷售組織",
  "label.scheduleddeliverydate": "預計交貨日期",
  "label.selectpaymentmethod": "選擇您的付款方式",
  "label.selectsalesorganisation": "選擇銷售組織",
  "label.shelflife": "保存期限",
  "label.shippinginstructions": "運輸說明",
  "label.shipto": "運送到",
  "label.shiptoaddress": "收貨人地址",
  "label.shiptoaddresses": "收貨人地址",
  "label.shiptoaddressincorrect": "收貨人選擇很重要，因為它可以按交貨地點顯示正確的定價。如果您的收貨位址不正確，請通過聊天與我們聯繫",
  "label.shiptoaddressrequired": "收貨地址為必填",
  "label.shoppingcart": "購物車",
  "label.size": "尺寸",
  "label.soldtoaddress": "買受人地址",
  "label.sortby": "排序方式",
  "label.specifications": "規格",
  "label.statusacknowledged": "已收到，確認中",
  "label.statusclosed": "已結案",
  "label.statusopen": "處理中",
  "label.storageconditions": "儲存條件",
  "label.subtotal": "小計",
  "label.tab.attachedfiles": "附加的文件",
  "label.tab.attachnew": "附加新的",
  "label.tax": "稅",
  "label.temperatureconditions": "溫度條件",
  "label.termsandconditions": "銷售條款和條件",
  "label.timezone": "時區",
  "label.total": "總計",
  "label.type": "類型",
  "label.unitprice": "單價",
  "label.unnumber": "聯合國編號",
  "label.updated": "更新",
  "label.user": "用戶",
  "label.validfrom": "有效期自",
  "label.validto": "有效至",
  "label.viewquote": "查看報價",
  "label.viewvideos": "觀看操作視頻",
  "label.yes": "是的",
  "label.yourproductnumber": "您的產品編號",
  "languageselection.modal.areyousure": "您確定要更改語言嗎？",
  "languageselection.modal.confirm": "是的，更改語言",
  "languageselection.modal.description": "更改您的語言將影響您在 Brenntag Connect 中的所有電子郵件和每個用戶界面。",
  "languageselection.modal.title": "更改首選的語言",
  "location.shipto.notavailable": "此產品不適用於您選擇的送貨地點。請選擇其它地點。",
  "logout.changeswillbelost": "如果您退出，此頁面上的更改將丟失。",
  "logout.confirmlogout": "您確定要繼續嗎？",
  "logout.itemsinyourshoppingcartcanbelost": "如果您退出，您購物車中的商品可能會丟失。",
  "message.accessrestricted": "您似乎沒有權限來執行您嘗試執行的操作。如果這不正確，請聯繫您的管理員。",
  "message.admincsrredirect": "看來您具有更高的權限並且在錯誤的位置！",
  "message.areyousure": "是否確定？",
  "message.changesalesorg": "更改銷售組織將影響您的產品目錄、訂單列表、報價、發票以及 Brenntag Connect 購物車中的所有當前項目。您可以隨時將其改回。",
  "message.changeswillbelost": "此頁面上的更改將丟失。",
  "message.documentnotfound": "已識別出一個錯誤，錯誤可能由於文件重複或損壞，或者無法加載新文件。",
  "message.noitemstoshow": "抱歉，沒有項目可顯示",
  "message.noprices": "通過聊天與我們聯繫以索取此產品的價格",
  "message.pagenotfound": "這個頁面好像不見了",
  "message.productnaforshipto": "收貨人不能用於索取報價，請選擇另一個客戶。",
  "order.cancelmodal.button": "要求取消訂單",
  "order.cancelmodal.question": "您確定要取消以下訂單嗎？",
  "order.cancelmodal.questionfollowup": "一旦您確認取消請求，您將無法恢復操作",
  "order.cancelmodal.title": "要求取消訂單",
  "order.cancelmodal.title.poabbr": "採購單號",
  "order.coadocument": "CoA 文件",
  "order.confirmationdocument": "訂單確認",
  "order.history.batch": "批次",
  "order.history.batch_amount": "批號數量",
  "order.history.bill_to": "付款人",
  "order.history.comment_from_user": "備註",
  "order.history.deliveryNumber": "交貨編號",
  "order.history.delivery_date": "交貨日期",
  "order.history.delivery_information": "交貨信息",
  "order.history.hide": "隱藏",
  "order.history.missing_productname": "產品名稱不可用。",
  "order.history.nologs": "此訂單沒有紀錄。",
  "order.history.number": "號碼",
  "order.history.orderDetails": "訂單詳細內容",
  "order.history.orderStatus": "訂單狀態",
  "order.history.order_amount": "訂單數量",
  "order.history.payment_terms": "付款條件",
  "order.history.pricing_unit_value": "單位定價",
  "order.history.quantity_calculated": "計算數量",
  "order.history.requested_delivery_date": "要求的交貨日期",
  "order.history.ship_to": "收貨人",
  "order.history.shipping_instructions": "運輸說明",
  "order.history.show": "顯示",
  "order.history.sold_to": "買受人",
  "order.history.status": "狀態",
  "order.history.subtotal_value": "小計值",
  "order.history.title": "訂單歷史記錄",
  "order.history.total_value": "總金額",
  "order.invoice.download": "發票下載",
  "order.invoice.title": "發票",
  "order.invoice.titlePlural": "發票",
  "order.invoice.view": "查看",
  "order.requestchange.allorderlinesdeleted": "您的訂單必須至少有一項產品才能保持有效。要取消訂單，請選擇「請求取消」或通過聊天與我們聯繫。",
  "order.requestchange.close": "關閉",
  "order.requestchange.closeeditmode": "關閉編輯模式",
  "order.requestchange.closeeditmodeconfirmation": "是的，關閉編輯模式",
  "order.requestchange.closewarning": "您確定要關閉更改請求嗎？",
  "order.requestchange.discardedwarning": "對此訂單所做的所有未保存的修改都將被丟棄並且不會被考慮。",
  "order.requestchange.leavewarning": "您確定要離開此頁面嗎？",
  "order.requestchange.placechangerequest": "地點變更請求",
  "order.requestchange.productnotavailable": "產品或價格不再適用於更改請求，請通過聊天與我們聯繫。",
  "order.requestchange.requestchange": "要求更改",
  "order.requestchange.shiptoaddressnotavailable": "此訂單無法使用此收貨人地址，請選擇其他收貨地址或通過聊天與我們聯繫。",
  "order.requestchange.shiptoaddressnotavailablewarning": "收貨人地址不可用",
  "order.status.Acknowledged": "已收到，確認中",
  "order.status.Cancelled": "已取消",
  "order.status.Closed": "已結案",
  "order.status.Confirmed": "已確認",
  "order.status.Invoiced": "已開具發票",
  "order.status.Open": "處理中",
  "order.status.OutForDelivery": "預計交貨",
  "order.status.Submitted": "提交",
  "order.success.message": "您的訂單現在由 Brenntag 團隊審核。審核完成後，您將收到一封確認，其中強調了交付的詳細信息。如果您有任何疑問或想進行任何更改，請通過聊天聯繫 Brenntag 團隊。",
  "order.success.title": "您的訂單已提交",
  "page.AccessRestricted": "權限受限",
  "page.CustomerList": "客戶",
  "page.Home": "首頁",
  "page.InvoiceList": "發票",
  "page.NotFound": "找不到頁面 (404)",
  "page.OrderList": "訂單",
  "page.PaymentInvoice": "線上付款",
  "page.ProductList": "產品",
  "page.Profile": "我的個人資料",
  "page.QuoteList": "報價",
  "page.SearchResultsFor": "搜尋結果",
  "page.TermsAndConditions": "銷售條款和條件",
  "page.TermsOfUse": "使用條款 - Brenntag Connect",
  "page.UserList": "用戶",
  "paymentInvoice.error": "無法檢索您的發票。請刷新頁面並重試。",
  "paymentInvoice.infoCard.credit": "信用",
  "paymentInvoice.infoCard.creditcardStoreInfo": "Brenntag 不會存儲客戶的任何信用卡信息。",
  "paymentInvoice.infoCard.debitNote": "Debit note",
  "paymentInvoice.infoCard.downloadpdf": "下載PDF",
  "paymentInvoice.infoCard.invoice": "發票/商業發票",
  "paymentInvoice.infoCard.price": "價格",
  "paymentInvoice.infoCard.review": "點擊查看我們的",
  "paymentInvoice.infoCard.terms": "銷售條款和條件",
  "paymentRedirect.error.heading": "出了點問題",
  "paymentRedirect.error.subtitle": "請重試或通過聊天與我們聯繫。",
  "paymentRedirect.error.title": "付款過程中出現錯誤，未支付發票/debit note",
  "paymentRedirect.invoiceList": "發票清單",
  "paymentRedirect.invoiceNumber": "發票號碼",
  "paymentRedirect.paidAmount": "已付金額",
  "paymentRedirect.paymentReference": "付款憑據",
  "paymentRedirect.pending.heading": "待確認",
  "paymentRedirect.pending.subtitle": "確認付款後，將由 Brenntag 團隊處理，狀態將相應地更新。",
  "paymentRedirect.pending.title": "您的付款正在等待確認",
  "paymentRedirect.refused.heading": "付款被拒絕",
  "paymentRedirect.refused.subtitle": "請使用其他付款方式重試。",
  "paymentRedirect.refused.title": "您的付款被拒絕，因此未成功",
  "paymentRedirect.success.heading": "謝謝",
  "paymentRedirect.success.subtitle": "您的發票已被支付。 Brenntag 團隊將處理付款並更新發票狀態。",
  "paymentRedirect.success.title": "您已成功付款，您的需求正在處理中",
  "paymentterms.A001": "120 DAYS FROM INV DD, BY 15TH",
  "paymentterms.A002": "15 DAYS FROM INV DD, BY 25T",
  "paymentterms.A003": "15 DAYS FROM INV DD, BY 5TH",
  "paymentterms.A004": "30 DAYS FROM INV DATE, BY 10TH",
  "paymentterms.A005": "30 DAYS FROM INV DATE, BY 15TH",
  "paymentterms.A006": "30 DAYS FROM INV DATE, BY 20TH",
  "paymentterms.A007": "30 DAYS FROM INV DATE, BY 25TH",
  "paymentterms.A008": "45 DAYS FROM INV DATE, BY 20TH",
  "paymentterms.A009": "45 DAYS FROM INV DATE, BY 25TH",
  "paymentterms.A010": "60 DAYS FROM INV DATE, BY 10TH",
  "paymentterms.A011": "60 DAYS FROM INV DATE, BY 15TH",
  "paymentterms.A012": "60 DAYS FROM INV DATE, BY 20TH",
  "paymentterms.A013": "60 DAYS FROM INV DATE, BY 25TH",
  "paymentterms.A014": "75 DAYS FROM INV DATE, BY EOM",
  "paymentterms.A015": "90 DAYS FROM INV DATE, BY 10TH",
  "paymentterms.A016": "90 DAYS FROM INV DATE, BY 15TH",
  "paymentterms.A017": "90 DAYS FROM INV DATE, BY 20TH",
  "paymentterms.A018": "90 DAYS FROM INV DATE, BY 25TH",
  "paymentterms.A019": "60 DAYS FROM INV DATE, BY 26TH",
  "paymentterms.A020": "45 DAYS FROM INV DATE BY 10TH",
  "paymentterms.A021": "0-10:20,11-20:EoM,>=21 NxtM10",
  "paymentterms.A022": "INV 26-10:PAY 14,11-25: PAY 28",
  "paymentterms.A023": "CUT OFF 20TH, PAY ON 28TH",
  "paymentterms.A024": "45D FR INV;PAY 2ND/12TH/22ND",
  "paymentterms.A025": "45D (CUT-OFF 25TH) BY 15TH",
  "paymentterms.A026": "150D FROM INV DATE, PAY 25TH",
  "paymentterms.B004": "4 DAYS FROM INV DATE",
  "paymentterms.B005": "5 DAYS FROM INV DATE",
  "paymentterms.B007": "7 DAYS FROM INV DATE",
  "paymentterms.B009": "9 DAYS FROM INV DATE",
  "paymentterms.B010": "10 DAYS FROM INV DATE",
  "paymentterms.B013": "13 DAYS FROM INV DATE",
  "paymentterms.B014": "14 DAYS FROM INV DATE",
  "paymentterms.B015": "15 DAYS FROM INV DATE",
  "paymentterms.B018": "18 DAYS FROM INV DATE",
  "paymentterms.B020": "20 DAYS FROM INV. DATE",
  "paymentterms.B021": "21 DAYS FROM INV DATE",
  "paymentterms.B022": "22 DAYS FROM INV DATE",
  "paymentterms.B028": "28 DAYS FROM INV DATE",
  "paymentterms.B029": "29 DAYS FROM INV DATE",
  "paymentterms.B030": "30 DAYS FROM INV DATE",
  "paymentterms.B037": "37 DAYS FROM INV DATE",
  "paymentterms.B038": "38 DAYS FROM INV DATE",
  "paymentterms.B040": "40 DAYS FROM INV DATE",
  "paymentterms.B045": "45 DAYS FROM INV DAT",
  "paymentterms.B050": "50 天（從 INV 日期算起）",
  "paymentterms.B055": "55 天（從 INV 日期算起）",
  "paymentterms.B060": "60 DAYS FROM INV DATE",
  "paymentterms.B065": "65 DAYS FROM INV DATE",
  "paymentterms.B068": "68 DAYS FROM INV DATE",
  "paymentterms.B070": "70 DAYS FROM INV DATE",
  "paymentterms.B075": "75 DAYS FROM INV DATE",
  "paymentterms.B080": "80 DAYS FROM INV DATE",
  "paymentterms.B085": "85 DAYS FROM INV. DATE",
  "paymentterms.B090": "90 DAYS FROM INV DATE",
  "paymentterms.B105": "105 DAYS FROM INV DATE",
  "paymentterms.B120": "120 DAYS FROM INV DATE",
  "paymentterms.B150": "150 DAYS FROM INV DATE",
  "paymentterms.B180": "180 DAYS FROM INV DATE",
  "paymentterms.B360": "360 DAYS FROM INV DATE",
  "paymentterms.BA01": "50% ADV, BALANCE 30 DAYS INV",
  "paymentterms.BA02": "30% ADV, BALANCE 30 DAYS INV",
  "paymentterms.BA03": "60% ADV, 40% PDC UPON DEL 30D",
  "paymentterms.BA04": "30%TT ADV AND 70 % TT AT SIGHT",
  "paymentterms.BA05": "30%TT ADV AND 70 % DP AT SIGHT",
  "paymentterms.BA06": "80% TT ADV AND 20% TT AT SIGHT",
  "paymentterms.BA07": "20% TT ADV 80% DP AT SIGHT",
  "paymentterms.BA08": "28% TT ADV 72% 60D FR INV DATE",
  "paymentterms.BA09": "70% TT ADV 30% DP AT SIGHT",
  "paymentterms.BA10": "50% TT ADV 50% DP AT SIGHT",
  "paymentterms.BA11": "20% TT ADV 80% TT AT SIGHT",
  "paymentterms.BA12": "40% Advance, 60% B/L date",
  "paymentterms.BA13": "50% Advance, 50% BL date",
  "paymentterms.BA14": "50% ADV, BALANCE 45 DAYS INV",
  "paymentterms.BA15": "50% ADV BAL 45 DAYS BL DATE",
  "paymentterms.BA16": "50% TT ADV, 50 % LC AT SIGHT",
  "paymentterms.BA17": "50% ADV, 50% At SIGHT B/L COPY",
  "paymentterms.BA18": "70% TT ADV, 30% TT AT SIGHT",
  "paymentterms.BA19": "20% TT ADVANCE 80% COD",
  "paymentterms.BA20": "30% DP,70% after 60 days B/L",
  "paymentterms.BA21": "50% ADV, 50% AT SIGHT INV DATE",
  "paymentterms.BA22": "50% Advance 50% Immediate",
  "paymentterms.BA23": "70% TT AT SIGHT,30% TT 75 DAYS",
  "paymentterms.BA24": "50% TT ADV, 50% TT AT SIGHT",
  "paymentterms.BA25": "30% ADV, 70% BL DATE",
  "paymentterms.BA26": "10% DEP AGST PI，90% TT@SIGHT",
  "paymentterms.BA27": "10% TT ADV, 90% DP AT SIGHT",
  "paymentterms.BA28": "15% TT ADV, 85% DP AT SIGHT",
  "paymentterms.BA29": "40% ADV, BAL COD",
  "paymentterms.BA30": "30% TT ADV, 70% 30D AFT B/L",
  "paymentterms.BA31": "90% CASH IN ADV, 10% TT 90DAYS",
  "paymentterms.BA32": "50% TT ADV, 50% TT 15D FR B/L",
  "paymentterms.BA33": "50% TT ADV, 50% 30D AFT B/L",
  "paymentterms.BA34": "60% ADV, 40% PDC UPON DEL 30D",
  "paymentterms.BA35": "50% ADV/50% 60DAYS FROM INVDAY",
  "paymentterms.BADV": "ADV PAYMENT",
  "paymentterms.BB05": "5 DAYS FROM BL DATE",
  "paymentterms.BB07": "7 DAYS FROM BL DATE",
  "paymentterms.BB10": "10 DAYS FROM BL DATE",
  "paymentterms.BB14": "14 DAYS FROM BL DATE",
  "paymentterms.BB15": "15 DAYS FROM BL DATE",
  "paymentterms.BB20": "20 DAYS FROM BL DATE",
  "paymentterms.BB21": "21 DAYS FROM BL DATE",
  "paymentterms.BB30": "30 DAYS FROM BL DATE",
  "paymentterms.BB35": "35 DAYS FROM BL DATE",
  "paymentterms.BB38": "38 DAYS FROM BL DATE",
  "paymentterms.BB40": "40 DAYS FROM BL DATE",
  "paymentterms.BB45": "45 DAYS FROM BL DATE",
  "paymentterms.BB46": "LC 45 DAYS FROM BL DATE",
  "paymentterms.BB50": "50 DAYS FROM BL DATE",
  "paymentterms.BB60": "60 DAYS FROM BL DATE",
  "paymentterms.BB65": "65 DAYS FROM BL DATE",
  "paymentterms.BB70": "70 DAYS FROM BL DATE",
  "paymentterms.BB75": "75 DAYS FROM BL DATE",
  "paymentterms.BB85": "85 DAYS FROM BL DATE",
  "paymentterms.BB90": "90 DAYS FROM BL DATE",
  "paymentterms.BB97": "97 DAYS FROM BL DATE",
  "paymentterms.BB98": "98 DAYS FROM BL DATE",
  "paymentterms.BB99": "99 DAYS FROM BL DATE",
  "paymentterms.BCBD": "CASH BEFORE DELIVERY",
  "paymentterms.BCOD": "CASH ON DELIVERY",
  "paymentterms.BD01": "D/A 15 DAYS FROM B/L DATE",
  "paymentterms.BD02": "D/A 30 DAYS FROM B/L DATE",
  "paymentterms.BD03": "D/A 45 DAYS FROM B/L DATE",
  "paymentterms.BD04": "D/A 60 DAYS FROM B/L DATE",
  "paymentterms.BD05": "D/A 75 DAYS FROM B/L DATE",
  "paymentterms.BD06": "D/A 90 DAYS FROM B/L DATE",
  "paymentterms.BD07": "D/A 120 DAYS FROM B/L DATE",
  "paymentterms.BD12": "DOC AGNST ACCEPTANCE 120 DAYS",
  "paymentterms.BD15": "DOC AGNST ACCEPTANCE 15 DAYS",
  "paymentterms.BD30": "DOC AGNST ACCEPTANCE 30 DAYS",
  "paymentterms.BD45": "DOC AGNST ACCEPTANCE 45 DAYS",
  "paymentterms.BD60": "DOC AGNST ACCEPTANCE 60 DAYS",
  "paymentterms.BD75": "DOC AGNST ACCEPTANCE 75 DAYS",
  "paymentterms.BD90": "DOC AGNST ACCEPTANCE 90 DAYS",
  "paymentterms.BDAA": "DOCUMENTS AGNST ACCEPTANCE",
  "paymentterms.BDAP": "DOC AGNST ACCEPTANCE AT SIGHT",
  "paymentterms.BE00": "0 DAYS FROM INV DATE, BY 20TH",
  "paymentterms.BE14": "15 DAYS FR INV DD, EOM BY 20TH",
  "paymentterms.BE15": "15 DAYS FR BL DD, EOM BY 20TH",
  "paymentterms.BE16": "EOM 15 DAYS",
  "paymentterms.BE20": "20 DAYS FR INV DD, EOM BY 20TH",
  "paymentterms.BE21": "20 DAYS FR BL DD, EOM BY 20TH",
  "paymentterms.BE22": "20 DAYS FR BL DD, EOM BY 20TH",
  "paymentterms.BE23": "20 DAYS EOM BY 25TH",
  "paymentterms.BE30": "EOM 30 DAYS BY 20TH",
  "paymentterms.BE31": "EOM BY 25TH",
  "paymentterms.BE32": "32 days end of month by 2nd",
  "paymentterms.BE33": "60 days end of month by 2nd",
  "paymentterms.BE45": "45 DAYS EOM",
  "paymentterms.BE60": "60 DAYS EOM",
  "paymentterms.BE61": "60 DAYS EOM BY 20TH",
  "paymentterms.BE62": "60 DAYS EOM BY 15TH",
  "paymentterms.BE63": "60 days end of month by 4th",
  "paymentterms.BE90": "90 DAYS EOM",
  "paymentterms.BE91": "90 DAYS EOM BY 5TH",
  "paymentterms.BIMM": "IMMEDIATE",
  "paymentterms.BL15": "LC 15 DAYS AT SIGHT",
  "paymentterms.BL21": "LC 21 DAYS AT SIGHT",
  "paymentterms.BL30": "LC 30 DAYS AT SIGHT",
  "paymentterms.BL45": "LC 45 DAYS AT SIGHT",
  "paymentterms.BL60": "LC 60 DAYS AT SIGHT",
  "paymentterms.BL61": "LC 60 DAYS BL",
  "paymentterms.BL75": "LC 75 DAYS AT SIGHT",
  "paymentterms.BL90": "LC 90 DAYS AT SIGHT",
  "paymentterms.BL91": "LC 90 DAYS BL",
  "paymentterms.BLAS": "LC PAYMENT AT SIGHT",
  "paymentterms.BP12": "DOCUMENTS AGNST PAYTS 120 DAYS",
  "paymentterms.BP30": "DOCUMENTS AGNST PAYTS 30 DAYS",
  "paymentterms.BP60": "DOCUMENTS AGNST PAYTS 60 DAYS",
  "paymentterms.BPAA": "D/P AT SIGHT",
  "paymentterms.BTAS": "TT AT SIGHT",
  "paymentterms.CAD1": "CASH AGAINST DOCUMENT",
  "paymentterms.CBO1": "CBO",
  "paymentterms.CBO2": "30% CBO, 70% CBD",
  "paymentterms.CBO3": "50% CBO，50% CBD",
  "paymentterms.CBO4": "50% CBO，50% COD",
  "paymentterms.CBO5": "50% CBO, 50% 30 DAYS FROM INV",
  "paymentterms.CNMT": "CNMT - CONSIGNMENT",
  "paymentterms.D001": "TT AGAINST DOCUMENT",
  "paymentterms.D002": "TT IN ADVANCE",
  "paymentterms.D004": "TT EOM 30D BY 20TH FRM BL DD",
  "paymentterms.D005": "TT 30 DAYS FROM INVOICE DATE",
  "paymentterms.D006": "TT 45 DAYS FROM BL DATE",
  "paymentterms.D007": "TT 45 DAYS FROM INV DATE",
  "paymentterms.D008": "TT 60 DAYS FROM INVOICE DATE",
  "paymentterms.D010": "TT 65 DAYS FROM  B/L Date",
  "paymentterms.D011": "TT 25 DAYS FROM INVOICE DATE",
  "paymentterms.D012": "TT AGAINST BL",
  "paymentterms.D013": "7 DAYS T/T AT SIGHT",
  "paymentterms.D014": "T/T BEFORE DELIVERY",
  "paymentterms.D015": "TT UPON ORDER CONFIRMATION",
  "paymentterms.D016": "TT 2 DAYS FROM INVOICE DATE",
  "paymentterms.D017": "TT 90 DAYS FROM INVOICE DATE",
  "paymentterms.DD01": "DIRECT DEBIT 30 DAYS",
  "paymentterms.DD02": "DIRECT DEBIT 60 DAYS",
  "paymentterms.DD03": "DIRECT DEBIT 90 DAYS",
  "paymentterms.E001": "EOM 30 DAYS BY 10th",
  "paymentterms.E002": "EOM 30 DAYS BY 15TH",
  "paymentterms.E003": "EOM 30 DAYS BY 20TH",
  "paymentterms.E004": "EOM 30 DAYS BY 25TH",
  "paymentterms.E005": "EOM 60 DAYS BY 10TH",
  "paymentterms.E006": "EOM 60 DAYS BY 15TH",
  "paymentterms.E007": "EOM 60 DAYS BY 20TH",
  "paymentterms.E008": "EOM 60 DAYS BY 25TH",
  "paymentterms.E009": "EOM 90 DAYS BY 10TH",
  "paymentterms.E010": "EOM 90 DAYS BY 15TH",
  "paymentterms.E011": "EOM 90 DAYS BY 20TH",
  "paymentterms.E012": "EOM 90 DAYS BY 25TH",
  "paymentterms.E013": "EOM",
  "paymentterms.E014": "EOM 30 DAYS",
  "paymentterms.E015": "EOM 30 DAYS BY 5th",
  "paymentterms.E016": "EOM 30 DAYS BY 10th",
  "paymentterms.E017": "EOM 30D BY 20th",
  "paymentterms.E018": "EOM 30D BY 25th",
  "paymentterms.E019": "EOM 30 DAYS (CUT-OFF 25th)",
  "paymentterms.E020": "EOM 30D (CUT-OFF 25th) BY 5TH",
  "paymentterms.E021": "EOM 30D (CUT-OFF 25th) BY 10TH",
  "paymentterms.E022": "EOM 45 DAYS (CUT-OFF 25th)",
  "paymentterms.E023": "EOM 60 DAYS",
  "paymentterms.E024": "EOM 60 DAYS BY 5th",
  "paymentterms.E025": "EOM 60 DAYS BY 10TH",
  "paymentterms.E026": "EOM 60 DAYS BY 15TH",
  "paymentterms.E027": "EOM 60 DAYS (CUT-OFF 25th)",
  "paymentterms.E028": "EOM 60D (CUT-OFF 25th) BY 5TH",
  "paymentterms.E029": "EOM 60D (CUT-OFF 25th) BY 10TH",
  "paymentterms.E030": "EOM 90 DAYS",
  "paymentterms.E031": "EOM 90 DAYS BY 7TH",
  "paymentterms.E032": "EOM 90 DAYS (CUT-OFF 20th)",
  "paymentterms.E033": "EOM 90 DAYS (CUT-OFF 25th)",
  "paymentterms.E034": "EOM BY 5TH",
  "paymentterms.E035": "EOM BY 10TH",
  "paymentterms.E036": "EOM 30D (CUT-OFF 20th) BY 15TH",
  "paymentterms.E037": "EOM 90D (CUT-OFF 25th) by 7th",
  "paymentterms.E038": "EOM 45 DAYS (CUT-OFF 25) BY 5",
  "paymentterms.E039": "EOM 60 DAYS (CUT-OFF 20th)",
  "paymentterms.E040": "EOM 90 DAYS (CUT-OFF 25) BY 8",
  "paymentterms.E041": "EOM 60 DAYS (CUT-OFF 25th) 15",
  "paymentterms.E042": "EOM 90 DAYS (CUT-OFF 25th) 5th",
  "paymentterms.E043": "EOM 90 DAYS (CUT-OFF 25th) 10",
  "paymentterms.E044": "EOM 90 DAYS (CUT-OFF 25th)15",
  "paymentterms.E045": "EOM 90 DAYS (CUT-OFF 25th)20th",
  "paymentterms.E046": "EOM 120 DAYS(CUT-OFF 25th)15th",
  "paymentterms.E047": "EOM 30 DAYS (CUT-OFF 25th)15th",
  "paymentterms.E048": "DUE SAME DAY NEXT MTH",
  "paymentterms.E049": "EOM 30 DAYS (DUE ON 27TH)",
  "paymentterms.E050": "EOM 60 DAYS DUE 25th",
  "paymentterms.E051": "EOM 210D",
  "paymentterms.E052": "EOM 105D",
  "paymentterms.E053": "EOM 60 DAYS (CUT-OFF 20TH) 20",
  "paymentterms.E054": "EOM 30 DAYS (CUT-OFF  20th)",
  "paymentterms.E055": "EOM 30D (CUT_OFF 25TH) BY 16TH",
  "paymentterms.E056": "EOM 85D (CUT-OFF 25TH)",
  "paymentterms.E057": "EOM 90D (DUE 5TH FOLLOWING)",
  "paymentterms.E058": "EOM 120D",
  "paymentterms.E059": "EOM (CUT-OFF 25TH) BY 5TH",
  "paymentterms.E060": "EOM 45 DAYS BY 15TH",
  "paymentterms.E061": "64 DAYS FROM EOM",
  "paymentterms.E062": "EOM BY 10TH",
  "paymentterms.E063": "EOM BY 26TH",
  "paymentterms.E064": "EOM 31 days",
  "paymentterms.E065": "EOM 50 DAYS (CUT-OFF 24th)",
  "paymentterms.E120": "120 DAYS EOM",
  "paymentterms.EA65": "65 DAYS ETA",
  "paymentterms.EM15": "EOM 15 DAYS",
  "paymentterms.EM20": "EOM 20 DAYS",
  "paymentterms.EM30": "30 DAYS EOM",
  "paymentterms.EM45": "EOM 45 DAYS",
  "paymentterms.EM65": "EOM 65 DAYS",
  "paymentterms.EM75": "EOM 75 DAYS",
  "paymentterms.EQ01": "End of Quarter (by 20th)",
  "paymentterms.GR10": "10 DAYS AFTER GOODS RECEIPT",
  "paymentterms.GR30": "30 DAYS AFTER GOODS RECEIPT",
  "paymentterms.IK00": "Within 5 days 3% cash discount",
  "paymentterms.L001": "LC 150 DAYS AT SIGHT",
  "paymentterms.L002": "LC 180 DAYS AT SIGHT",
  "paymentterms.L003": "LC 105 DAYS BL",
  "paymentterms.L004": "LC 120 DAYS BL",
  "paymentterms.L005": "LC 150 DAYS BL",
  "paymentterms.L006": "LC 180 DAYS BL",
  "paymentterms.L007": "LC 15 DAYS BL",
  "paymentterms.L030": "LC 30 DAYS BL",
  "paymentterms.L105": "105 DAYS FROM BL DATE",
  "paymentterms.L120": "120 DAYS FROM BL DATE",
  "paymentterms.L150": "150 DAYS FROM BL DATE",
  "paymentterms.L180": "L 180 DAYS FROM BL DATE",
  "paymentterms.LD01": "LAST DAY NEXT MTH",
  "paymentterms.LD02": "LAST DAY OF MTH AFT NEXT MTH",
  "paymentterms.LD03": "LAST DAY OF THREE MONTH LATER",
  "paymentterms.LVT0": "16 days 2%, 31 days net",
  "paymentterms.M001": "3 MONTH LATER BY 5TH",
  "paymentterms.M002": "3 MONTH LATER BY 5TH",
  "paymentterms.MVT0": "10 days 3%, 16  2%, 31 net",
  "paymentterms.P001": "60 DAYS ETA",
  "paymentterms.P002": "90 DAYS ETA",
  "paymentterms.P003": "15 DAYS FROM ETA HCM PORT",
  "paymentterms.P004": "60 DAYS FROM ETA, PAY ON 26TH",
  "paymentterms.PBD1": "PDC BEFORE DEL 30 DAYS",
  "paymentterms.PBD2": "PDC BEFORE DEL 45 DAYS",
  "paymentterms.PBD3": "PDC BEFORE DEL 60 DAYS",
  "paymentterms.PBD4": "PDC BEFORE DEL 90DAYS FROM INV",
  "paymentterms.PBD5": "PDC BEFORE DEL 15 DAYS",
  "paymentterms.PDC1": "30 DAYS PDC FROM INV DATE",
  "paymentterms.PDC2": "60 DAYS PDC FROM INV DATE",
  "paymentterms.PDC3": "45 DAYS PDC FROM INV DATE",
  "paymentterms.PDC4": "15 DAYS PDC FROM INV DATE",
  "paymentterms.PDC5": "90 DAYS PDC FROM INV DATE",
  "paymentterms.PUD1": "PDC UPON DEL 15 DAYS FROM INV",
  "paymentterms.PUD2": "PDC UPON DEL 30 DAYS FROM INV",
  "paymentterms.PUD3": "PDC UPON DEL 45 DAYS FROM INV",
  "paymentterms.PUD4": "PDC UPON DEL 60 DAYS FROM INV",
  "paymentterms.PUD5": "PDC UPON DEL 90 DAYS FROM INV",
  "paymentterms.TX07": "7 DAYS AFTER STOCK ARRIVAL",
  "paymentterms.TX30": "30 DAYS DECLARATION",
  "paymentterms.TX45": "45 DAYS DECLARATION",
  "paymentterms.TX60": "60 DAYS DECLARATION",
  "paymentterms.TX90": "90 DAYS DECLARATION",
  "paymentterms.WALL": "99% forever",
  "paymentterms.WL01": "12 days net",
  "paymentterms.Z001": "custom payment term (test)",
  "paymentterms.ZB00": "Pay immediately w/o deduction",
  "paymentterms.ZB01": "14 Days 3%, 30/2%, 45 net",
  "paymentterms.ZB02": "8 days 5%, 14/2%, 21 net",
  "paymentterms.ZB03": "20 days 2%, 30 days net",
  "paymentterms.ZB04": "10 days 4%, 20/2%, 30 net",
  "paymentterms.ZB05": "5 days 2%, 10 days net",
  "phone.landline": "電話",
  "phone.mobile": "手機",
  "product.altsizes.loadmore": "加載更多替代尺寸",
  "product.discount.saveamount": "保存@@AMOUNT@@",
  "product.discount.savingspercentage": "@@PERCENTAGE@@節省",
  "product.documentType.msds": "SDS文件",
  "product.documentType.tds": "TDS文件",
  "product.documenterror": "無法檢索文件",
  "product.loadingdocuments": "載入文件",
  "product.nodocuments": "沒有可用的文件",
  "product.safetyinformation": "安全信息",
  "product.type.nonvaluated": "Non-Valuated Materials",
  "product.type.packaging": "包裝",
  "product.type.returnable": "可回收包裝",
  "product.type.sample": "樣品",
  "product.type.services": "服務",
  "product.type.tolling": "加工",
  "product.type.tolling-raw-material-nonvaluated": "加工的原材料未估價",
  "product.type.tradinggoods": "交易商品",
  "quote.date": "報價日期",
  "quote.decline": "拒絕報價",
  "quote.details": "報價詳情",
  "quote.number": "報價編號",
  "quote.requoteproduct": "重新報價產品",
  "quote.validfrom": "有效期自",
  "quote.validto": "有效至",
  "quote.value": "報價金額",
  "quotestatus.Declined": "拒絕",
  "quotestatus.Expired": "已過期",
  "quotestatus.InProgress": "進行中",
  "quotestatus.Open": "處理中",
  "quotestatus.Ordered": "已訂購",
  "quotestatus.Submitted": "提交",
  "quotestatus.Upcoming": "即將提供",
  "regex.placeordertermsandconditions": "下訂單即表示您接受我們的@@TERMS_AND_CONDITIONS@@",
  "regex.reviewtermsandconditions": "單擊此處查看我們的@@TERMS_AND_CONDITIONS@@",
  "requestcancellation.request": "Brenntag 客戶服務團隊，我想使用訂單號：@@ORDER_NUMBER@@ 和客戶號碼：@@CUSTOMER_NUMBER@@ 請求取消訂單。請根據需要提供確認信息或更多信息。",
  "requestchanges.message.billToAddress": "- 以前的帳單地址：@@LOCATION_OLD@@ - 新帳單地址：@@LOCATION_NEW@@",
  "requestchanges.message.cancelproduct": "- 取消此產品：產品：@@PRODUCT_NAME@@ 產品 ID：@@PRODUCT_NUMBER@@",
  "requestchanges.message.comments": "- 註釋：@@COMMENTS_OLD@@ → @@COMMENTS_NEW@@",
  "requestchanges.message.deliverydate": "- 要求的交貨日期：@@DATE_OLD@@ → @@DATE_NEW@@",
  "requestchanges.message.heading": "Brenntag 客戶服務團隊，您能否為我的訂單更改以下信息：客戶編號@@CUSTOMER_NUMBER@@ 訂單編號@@PURCHASE_ORDER_NUMBER@@ ---------",
  "requestchanges.message.orderline": "- 更改此產品：產品：@@PRODUCT_NAME@@ 產品 ID：@@PRODUCT_NUMBER@@ - 數量：@@QUANTITY_OLD@@ → @@QUANTITY_NEW@@ - 金額：@@AMOUNT_OLD@@ @@AMOUNT_UOM_OLD@@ → @@ AMOUNT_NEW@@@@AMOUNT_UOM_NEW@@",
  "requestchanges.message.shipToAddress": "- 之前的送貨地址：@@LOCATION_OLD@@ - 新的送貨地址：@@LOCATION_NEW@@",
  "requestquote.request": "Brenntag 客戶服務團隊，請提供以下報價： 客戶編號 @@CUSTOMER_NUMBER@@ 產品：@@PRODUCT_NAME@@ 產品 ID：@@PRODUCT_NUMBER@@ 請求數量：@@QUANTITY@@ 請求數量：@@REQUESTED_AMOUNT@ @送貨地址：@@SHIP_TO_ADDRESS@@ 要求送貨日期：@@REQUESTED_DELIVERY_DATE@@",
  "show_more.less": "顯示較少",
  "show_more.more": "顯示更多",
  "show_more.results": "顯示更多結果",
  "something.wrong": "哎呀！出了點問題。請再試一次",
  "something.wrong.documents": "哎呀！出了點問題",
  "sortinglabel.-currency": "貨幣 (Z-A)",
  "sortinglabel.-customerName": "客戶名稱 (Z-A)",
  "sortinglabel.-dueDate": "最新到期日",
  "sortinglabel.-grossAmount.amount": "應付金額由高至低",
  "sortinglabel.-invoiceNumber": "發票號碼 (Z-A)",
  "sortinglabel.-issueDate": "最新創建日期",
  "sortinglabel.-lastLoggedInAt": "最近上次登錄入",
  "sortinglabel.-lastUpdateDate": "最新更新",
  "sortinglabel.-name": "產品名稱 (Z-A)",
  "sortinglabel.-netAmount": "最高總額",
  "sortinglabel.-orderCreationDate": "最新訂購日期",
  "sortinglabel.-packaging.name": "包裝類型 (Z-A)",
  "sortinglabel.-quoteCreationDate": "最新報價日期",
  "sortinglabel.-username": "姓名 (Z-A)",
  "sortinglabel.-usertype": "用戶類型（外部優先）",
  "sortinglabel.currency": "貨幣 (A-Z)",
  "sortinglabel.customerName": "客戶名稱 (A-Z)",
  "sortinglabel.dueDate": "最舊的到期日",
  "sortinglabel.grossAmount.amount": "應付金額由低至高",
  "sortinglabel.invoiceNumber": "發票號碼 (A-Z)",
  "sortinglabel.issueDate": "最早的創建日期",
  "sortinglabel.lastLoggedInAt": "最早的上次登入時間",
  "sortinglabel.lastUpdateDate": "最早的更新",
  "sortinglabel.name": "產品名稱 (A-Z)",
  "sortinglabel.netAmount": "最低總額",
  "sortinglabel.orderCreationDate": "最早的訂購日期",
  "sortinglabel.packaging.name": "包裝類型 (A-Z)",
  "sortinglabel.quoteCreationDate": "最早的報價日期",
  "sortinglabel.relevance": "關聯",
  "sortinglabel.username": "名稱 (A-Z)",
  "sortinglabel.usertype": "用戶類型（內部優先）",
  "storageconditions.01": "一般儲存食品，製藥",
  "storageconditions.02": "一般存儲",
  "storageconditions.03": "危險儲存",
  "storageconditions.04": "冷藏室儲藏食品、製藥",
  "storageconditions.05": "易燃環境",
  "storageconditions.06": "陰涼處儲存",
  "storageconditions.07": "冷鏈存儲",
  "storageconditions.08": "氟化物儲存",
  "storageconditions.09": "氨儲存",
  "storageconditions.10": "不合格存儲",
  "storageconditions.11": "液體散裝存儲",
  "storageconditions.12": "生產區",
  "support.email": "support@brenntagconnect.com",
  "support.email.salesgroup.NL01": "orders.au@brenntag-asia.com",
  "support.email.topic": "查詢： {customer PO#}/ {quotation #}/ {customer ID}",
  "support.phonenumber": "123 3453 043",
  "temperatureconditions.01": ">25 至 40ºC",
  "temperatureconditions.02": ">15 到 25ºC，濕度可控",
  "temperatureconditions.03": ">8 到 15ºC，濕度可控",
  "temperatureconditions.04": ">0 到 8ºC，濕度可控",
  "temperatureconditions.05": ">-20 至 0ºC",
  "temperatureconditions.06": "-20℃及以下",
  "terms.agree": "是的我同意",
  "terms.description": "訪問或使用 Brenntag Connect 的任何部分，即表示您同意受這些使用條款的約束。如果您不同意本協議的所有條款和條件，您將無法訪問 Brenntag Connect 或使用其任何服務",
  "terms.disagree": "不，退出",
  "timeunit.many.day": "天",
  "timeunit.many.month": "月",
  "timeunit.many.week": "週數",
  "timeunit.many.year": "年",
  "timeunit.one.day": "日",
  "timeunit.one.month": "月",
  "timeunit.one.week": "星期",
  "timeunit.one.year": "年",
  "toast.error.coadocuments": "檢索 CoA 文檔時出了問題",
  "toast.error.createuser": "創建用戶時出了點問題",
  "toast.error.customernotfound": "出問題了。請聯繫Brenntag Connect。",
  "toast.error.customers": "檢索客戶時出了問題",
  "toast.error.invoices": "檢索發票數據時出了問題",
  "toast.error.languagechange": "語言更改失敗",
  "toast.error.orderdetails": "檢索訂單詳細信息時出了問題",
  "toast.error.orders": "檢索訂單歷史記錄時出了問題",
  "toast.error.placingorder": "下單時出了點問題",
  "toast.error.price": "檢索價格時出錯",
  "toast.error.productdocuments": "檢索產品文檔時出了問題",
  "toast.error.products": "檢索產品數據時出了問題",
  "toast.error.quote": "檢索報價詳細信息時出了問題",
  "toast.error.quotereject": "拒絕報價時出了點問題",
  "toast.error.quotes": "檢索報價時出了問題",
  "toast.error.saveuser": "存檔用戶更改時出了問題",
  "toast.error.userinfo": "檢索用戶信息時出了問題",
  "toast.error.userservice": "檢索用戶數據時出了問題",
  "toast.error.userservice.emailaddressexists": "電子郵件地址為@@EMAIL@@ 的用戶已存在",
  "toast.error.userservice.permissionsoutsidesalesgroup": "您不能創建或修改您的銷售組之外的用戶",
  "toast.error.userservice.savefailed": "存檔用戶數據時出了問題",
  "toast.error.validatingcart": "驗證購物車時出了問題",
  "toast.success.createuser": "用戶@@USER@@ 創建成功",
  "toast.success.deleteuser": "用戶@@USER@@ 刪除成功",
  "toast.success.resetpassword": "我們剛剛向您發送了一封電子郵件至 @@EMAIL@@ 以重置您的密碼。",
  "toast.success.saveuser": "用戶@@USER@@保存成功",
  "user.accessrights": "訪問權限和語言",
  "user.accessrights.message": "為客戶設定訪問權限",
  "user.bcaccessstatus": "Brenntag Connect 權限狀態",
  "user.create": "創建用戶",
  "user.createdon": "創建於",
  "user.delete.confirmation": "這無法撤消，要繼續嗎？",
  "user.delete.message": "用戶@@USER@@ 將從系統中不可逆地刪除。",
  "user.edit": "修改用戶",
  "user.information": "用戶信息",
  "user.lastpasswordreset": "上次密碼重置",
  "user.modal.terminate.confirmation": "是否確實要終止此使用者？",
  "user.modal.terminate.message": "警告：被終止的使用者將無法再登錄Brenntag Connect。",
  "user.notes": "備註",
  "user.notes.placeholder": "範例：工作時間信息、備用聯繫人",
  "user.role": "角色",
  "user.save": "保存更改",
  "user.search.customer": "搜索客戶編號或名稱",
  "user.selectcustomer": "選擇客戶",
  "user.selectlanguage": "選擇語言",
  "user.view": "查看用戶",
  "userEdit.cancel.confirm": "您確定要取消嗎？",
  "userEdit.cancel.create.external": "取消“創建外部用戶”",
  "userEdit.cancel.create.internal": "取消“創建內部用戶”",
  "userEdit.cancel.edit.external": "取消“編輯外部用戶”",
  "userEdit.cancel.edit.internal": "取消“編輯內部用戶”",
  "userEdit.message.cannotedit": "您無法編輯此使用者的詳細資訊。如果您想編輯此使用者，請聯繫 Brenntag。",
  "userrole.Admin": "管理員",
  "userrole.CSR": "CSR",
  "userrole.ReadUser": "限讀取用戶",
  "userrole.SuperAdmin": "超級管理員",
  "userrole.User": "用戶",
  "userrole.UserAdmin": "用戶管理員",
  "userrole.UserManager": "用戶經理",
  "userrole.description": "用戶角色",
  "validationerror.invalid-date": "所選的日期無效",
  "validationerror.invalid-moq": "所選數量低於最小訂購量",
  "validationerror.not-authorized": "未經授權",
  "validationerror.not-found": "該產品不存在",
  "validationerror.price-changed": "此產品的價格已更新",
  "validationerror.price-mismatch": "部分價格已更新",
  "validationerror.price-not-found": "未找到此產品的價格。請通過聊天與我們聯繫以索取價格。",
  "validationerror.uom-mismatch": "該產品的計量單位不符合",
  "video.invoices": "發票",
  "video.invoices.description": "了解如何查找和下載發票",
  "video.ordering": "訂購和重新訂購",
  "video.ordering.description": "了解如何訂購和重新訂購產品",
  "video.orderlist": "查看訂單列表",
  "video.orderlist.description": "了解您的訂單列表和訂單歷史紀錄",
  "video.productsearch": "產品搜索",
  "video.productsearch.description": "了解如何搜索產品和查看產品詳細信息"
} as const
